import React, { useState } from "react";
import ModeListBox from "../ModeListBox/ModeListBox";
import { CategoryJsonModel } from "../../models/BlockTransportSystemJsonModel";
import { Button, Container, Stack } from "react-bootstrap";

interface IProps {
  exposureCategories: CategoryJsonModel[];
  listUpCategories: CategoryJsonModel[];
  selectedExposureCategories: CategoryJsonModel[];
  selectedListUpCategories: CategoryJsonModel[];
  onChangeSelectedExposureCategories: (categories: CategoryJsonModel[]) => void;
  onChangeSelectedListUpCategories: (categories: CategoryJsonModel[]) => void;
  onClickAdd: (categories: CategoryJsonModel[]) => void;
  onClickRemove: (categories: CategoryJsonModel[]) => void;
  onClickAddAll: () => void;
  onClickRemoveAll: () => void;
}

const ModeSettingBox: React.FC<IProps> = ({
  exposureCategories,
  listUpCategories,
  onClickAdd,
  onClickRemove,
  onClickAddAll,
  onClickRemoveAll,
})  => {
  const [selectedExposureIds, setSelectedExposureIds] = useState<string[]>([]);
  const [selectedListUpIds, setSelectedListUpIds] = useState<string[]>([]);

  const mapIdsToCategories = (
    ids: string[],
    source: CategoryJsonModel[]
  ) => source.filter(c => ids.includes(c.id));


  return (
    <Container fluid className="d-flex">
      <ModeListBox
        categories={exposureCategories}
        selectedCategoryIds={selectedExposureIds}
        onChangeSelectedCategoryIds={setSelectedExposureIds}
      />
      <Stack gap={2} className="m-2">
        <Button
          variant="outline-primary" className="text-nowrap"
          onClick={() => {
            const categories = mapIdsToCategories(
              selectedListUpIds,
              listUpCategories
            );
            onClickAdd(categories);
            setSelectedListUpIds([]);
          }}
        >
          {"<<추가"}
        </Button>
        <Button
          variant="outline-danger" className="text-nowrap"
          onClick={() => {
            const categories = mapIdsToCategories(
              selectedExposureIds,
              exposureCategories
            );
            onClickRemove(categories);
            setSelectedExposureIds([]);
          }}
        >
          {">>제거"}
        </Button>
        <Button
          variant="outline-primary" className="text-nowrap"
          onClick={() => onClickAddAll()}
        >
          {"All 추가"}
        </Button>
        <Button
          variant="outline-danger" className="text-nowrap"
          onClick={() => onClickRemoveAll()}
        >
          {"All 제거"}
        </Button>
      </Stack>
      <ModeListBox
        categories={listUpCategories}
        selectedCategoryIds={selectedListUpIds}
        onChangeSelectedCategoryIds={setSelectedListUpIds}
      />
    </Container>
  )
}

export default ModeSettingBox;